module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aNc91"))).then(() => parcelRequire('hEqeo'));